import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2019/gitlab-runner/pipeline.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2019/gitlab-runner/system.png");
